<template>
  <div>
    <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
      <base-dropdown>
        <base-button slot="title" type="success" class="dropdown-toggle">
          Search By - {{_.startCase(currentFilter)}}
        </base-button>
        <a @click.prevent="changeFilter('all')" class="dropdown-item" href="#">All Products</a>
        <a @click.prevent="changeFilter('categories')" class="dropdown-item" href="#">Category</a>
        <a @click.prevent="changeFilter('suppliers')" class="dropdown-item" href="#">Supplier</a>
        <a @click.prevent="changeFilter('brands')" class="dropdown-item" href="#">Brand</a>
      </base-dropdown>
    </base-header>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
      <div v-if="formId == 'addCategory'">
        <h6 class="heading-small text-muted mb-4">Add Sub-Category</h6>
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <base-input alternative="" label="Name" placeholder="" v-model="categoryName" input-classes="form-control"/>
              <base-input alternative="" label="Code" placeholder="" v-model="categoryCode" input-classes="form-control"/>
              <base-input alternative="" label="Remark">
                <textarea v-model="categoryRemark" rows="4" class="form-control" />
              </base-input>
            </a-tab-pane>
            <a-tab-pane v-if="categoryLevel == 3" tab="Category Settings" key="2">
              <dynamic-form :convertedJson="convertedJson" @valueUpdated="updateSettings"></dynamic-form>
            </a-tab-pane>
          </a-tabs>
                    
          <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn btn-success" @click="createData">Create</button>
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>

      <div v-if="formId == 'editCategory'">
        <h6 class="heading-small text-muted mb-4">Edit Category</h6>  
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <base-input alternative="" label="Name" placeholder="" v-model="categoryName" input-classes="form-control"/>
              <base-input alternative="" label="Code" placeholder="" v-model="categoryCode" input-classes="form-control"/>
              <base-input alternative="" label="Remark">
                <textarea v-model="categoryRemark" rows="4" class="form-control" />
              </base-input>
            </a-tab-pane>

            <a-tab-pane v-if="categoryLevel == 4" tab="Category Settings" key="2">
              <dynamic-form :key="componentKey" :convertedJson="convertedJson" :formSettings="formSettings" @valueUpdated="updateSettings"></dynamic-form>
            </a-tab-pane>
          </a-tabs>
                  
          <div v-if="serverType == 'ho'" class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn btn-success" @click="updateData">Update</button>
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>

          <div v-else class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>
    </a-drawer>

    <div class="container-fluid mt--7">
      <div class="card mb-3" style="min-height: 60vh">
        <div class="row no-gutters">   
          <!-- SIDEBAR -->
          <div class="col-md-4" style="border-right: 1px solid #e0e0e0; min-height: 60vh">
            <div v-if="currentFilter == 'categories'" class="card-body">
              <div class="row">
                <div class="col-md-12 no-gutters"><h2 class="card-title">Product Categories</h2></div>
              </div>
              
              <a-input style="margin-bottom: 8px" placeholder="Search Categories" @change="onChange"/>
              <a-tree class="draggable-tree" :defaultExpandedKeys="expandedKeys" :expandedKeys="expandedKeys" :autoExpandParent="autoExpandParent" draggable @expand="onExpand" @select="onSelect" :treeData="gData" :showLine="defaultExpandAll" @drop="onDrop">
                <template slot="title" slot-scope="{title}">
                  <span v-if="title.indexOf(searchValue) > -1">
                    {{title.substr(0, title.indexOf(searchValue))}}
                    <span style="color: #f50">{{searchValue}}</span>
                    {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
                  </span>
                  <span v-else>{{title}} </span>
                </template>
              </a-tree>
              
              <br><br><br><br>
            </div>

            <div v-else class="card-body">
              <div class="row">
                <div class="col-md-12 no-gutters"><h2 class="card-title">{{_.startCase(currentFilter)}}</h2></div>
              </div>
              <a-input style="margin-bottom: 8px" :placeholder="'Search ' + _.startCase(currentFilter)" @change="onChange" />
              <a-list size="small" :dataSource="data" style="height:550px; overflow-y: scroll;">
                <a-list-item slot="renderItem" slot-scope="item" :class="onRowClass(item.id)" @click.prevent="setParentId(item.id)" >&nbsp;&nbsp;{{item.name}}</a-list-item>
              </a-list>
            </div>

            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
              <div v-if="selectedNode != null && selectedKey != 2 && serverType == 'ho'">
                <button v-if="selectedNode.scopedSlots.level < 4" @click.prevent="showDrawer('addCategory')" type="button" class="btn btn-sm btn-primary float-right"> Add Sub-Category </button>     
                <button @click.prevent="showDrawer('editCategory')" type="button" class="btn btn-sm btn-success float-right mr-2"> Edit </button> 
                <button v-if="selectedNode.scopedSlots.level > 0" class="btn btn-sm mr-2 float-right btn-danger" @click.prevent="deleteData">Delete</button>
              </div>
              
              <div v-else-if="selectedNode != null && serverType == 'branch'">
                <button @click.prevent="showDrawer('editCategory')" type="button" class="btn btn-sm btn-success float-right mr-2"> View </button> 
              </div>
            </div>
          </div>

          <div class="col-md-8" style="border-right: 1px solid #e0e0e0; min-height: 60vh;">
            <div class="card-body">
              <!-- PRODUCT LIST -->
              <products-table title="Product List"></products-table>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ProductsTable from '../Tables/ProductsTable'
  import secureStorage from '../../controllers/secureStorage.js'
  import HTTPRequest from '../../controllers/httpRequest.js'
  import DynamicForm from '../DynamicForm.vue'
  import { mapState, mapActions } from 'vuex'
  // import { async } from 'q'

  var ObjGen = require('../../../node_modules/objgen/objgen.js').ObjGen;

  let gData = []
  const dataList = []
  const generateList = (data) => {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const key = node.key
      dataList.push({ key, title: node.title })
      if (node.children) {
        generateList(node.children, node.key)
      }
    }
  }

  const getParentKey = (key, tree) => {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some(item => item.key === key)) {
          parentKey = node.key
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children)
        }
      }
    }
    return parentKey
  }

  let node_ret = null
  const getNode = function (key, tree) {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if(node.key == key){
        node_ret = node 
      } else {
        if(node.children.length > 0){
          getNode(key, node.children)
        }
      }
    }
    return node_ret;
  }

  export default {
    components: {
      ProductsTable,
      DynamicForm
    },
    computed: {
      ...mapState(['endPoint', 'serverType', 'parentId', 'currentProfile', 'parameters'])
    },
    mounted: async function(){
      // if (this.currentFilter == 'products') {
        this.updateCurrentProfile("products")
        this.gData = await HTTPRequest.getRequest(this.endPoint + '/categories/tree_view', null)    
        gData = this.gData
        generateList(gData)
      // }

      this.setCurrentProfile("products");
    },
    data: function() {
      return {
        data: [],
        componentKey: 0,
        formSettings: {},
        convertedJson: null,
        categoryLevel: null,
        visible: false,
        categoryRemark: "",
        categoryName: "",
        categoryCode: "",
        defaultExpandAll: true,
        expandedKeys: [],
        searchValue: '',
        autoExpandParent: true,
        gData,
        formId: "",
        selectedNode: null,
        selectedKey: null,
        currentFilter: "categories",
        placeholder: this.currentFilter,
        authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
      }
    },
    watch: {
      currentFilter: async function(){
        if (this.currentFilter == "suppliers") {
          var suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers" , null)
          this.sort(suppliers.data);
          this.setParentId(0);
        } else if (this.currentFilter == "brands") {
          var brands = await HTTPRequest.getRequest(this.endPoint + "/brands" , null)
          this.sort(brands.data);
          this.setParentId(0);
        }
      },
      searchValue: async function(){
        if (this.currentFilter == "suppliers") {
          var suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers?name=" + this.searchValue , null)
          this.sort(suppliers.data);
        } else if (this.currentFilter == "brands") {
          var brands = await HTTPRequest.getRequest(this.endPoint + "/brands?name=" + this.searchValue , null)
          this.sort(brands.data);
        }
      }
    },
    methods: {
      ...mapActions(['updateCurrentProfile', 'updateParentId', 'updateParameters']),
      updateSettings(formSettings, settingsGrouping){
        this.formSettings = formSettings
      },
      setCurrentProfile(profile){
        this.updateCurrentProfile(profile)
        this.setParentId(0);
      },
      onRowClass (id) {
        return (id == this.parentId) ? 'alert-success' : ''
      },
      sort(data){
        data = data.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        this.data = data;
      },
      setParentId(id){
        this.updateParentId(id);
        if(this.currentFilter == 'brands'){
          this.updateParameters("?brand_id=" + this.parentId);
        } else if (this.currentFilter == 'suppliers'){
          this.updateParameters("?supplier_id=" + this.parentId);
        }
      },
      async showDrawer(type){
        this.formId = type
        this.visible = true
        var jsonField;
        if(type == 'addCategory'){
          this.clearData()
          this.categoryName = "New Level " + (this.categoryLevel + 1).toString()
          if(this.categoryLevel == 3){
            jsonField = await HTTPRequest.getRequest(this.endPoint + 'dynamic_forms/Product Category?field_name=profile_name' , null, null)   
            this.convertedJson = ObjGen.xJson(jsonField.template, {numSpaces: 2})
          }                
        }

        if(type == 'editCategory'){
          if(this.categoryLevel == 4){
            jsonField = await HTTPRequest.getRequest(this.endPoint + 'dynamic_forms/Product Category?field_name=profile_name' , null, null)   
            this.convertedJson = ObjGen.xJson(jsonField.template, {numSpaces: 2})
          }
        }
            
        if(this.serverType == 'branch'){
          var form = document.getElementById("form-proper")
          var elements = form.elements;
          for (var i = 0, len = elements.length; i < len; ++i) {
            elements[i].readOnly = true;
          }
        }
      },
      changeFilter(profile){
        this.currentFilter = profile
        this.placeholder = "Search " + this.currentFilter
      },

      // DRAWER FUNCTIONS
      onClose() {
        this.visible = false
        this.componentKey++
        this.formSettings = {}
      },
      async createData(){
        if(this.selectedNode == null){
          this.selectedKey = null
        }
        var categoryPayload = {category: {name: this.categoryName, code: this.categoryCode,  status: 'A', parent_category_id: this.selectedKey, remark: this.categoryRemark, category_settings: JSON.stringify(this.formSettings) } }
        this.gData = await HTTPRequest.postRequest(this.endPoint + 'categories/' , null, categoryPayload)   
        gData = this.gData
        generateList(gData)
        alert("Create Successful")
        this.clearData()
        this.onClose()
      },
      async deleteData(){

        if(this.selectedNode.children.length > 0){
          alert("You cannot delete a parent category.")
        } else {
          var categoryPayload = {category: {status: "D"} }
          this.gData = await HTTPRequest.putRequest(this.endPoint + 'categories/' + this.selectedKey , null, categoryPayload)   
          gData = this.gData
          generateList(gData)
          this.clearData()
          alert("Delete Successful")
          this.onClose()
        }

      },
      async updateData(){
        var categoryPayload = {category: {name: this.categoryName, code: this.categoryCode,  status: 'A', remark: this.categoryRemark, category_settings: JSON.stringify(this.formSettings)} }
        this.gData = await HTTPRequest.putRequest(this.endPoint + 'categories/' + this.selectedKey , null, categoryPayload)   
        gData = this.gData
        this.clearData()
        generateList(gData)
        alert("Update Successful")
        this.onClose()
      },
      clearData(){
        this.categoryName = null
        this.categoryCode = null
      },

      // TREE FUNCTIONS
      onExpand  (expandedKeys) {
        this.selectedNode = null
        this.expandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      onChange (e) {
        if (this.currentFilter == 'categories'){
          const value = e.target.value
          const expandedKeys = dataList.map((item) => {
            if (item.title.indexOf(value) > -1) {
              return getParentKey(item.key, gData)
            }
            return null
          }).filter((item, i, self) => item && self.indexOf(item) === i)
          Object.assign(this, {
            expandedKeys,
            searchValue: value,
            autoExpandParent: true,
          })
        } else {
          this.searchValue = e.target.value;
        }
      },
      async onSelect(info){
        var selectedNode = getNode(info[0], gData)
        this.selectedNode = selectedNode
        this.selectedKey = selectedNode.key
        this.categoryName = selectedNode.scopedSlots.title
        this.categoryCode = selectedNode.scopedSlots.code
        this.categoryLevel = selectedNode.scopedSlots.level
        this.categoryRemark = selectedNode.scopedSlots.remark
        var formSettings = await HTTPRequest.getRequest(this.endPoint + 'categories/' + this.selectedKey + "/get_settings" , null, null)   
        this.formSettings = JSON.parse(formSettings["settings"])
        this.componentKey++
      },
      async onDrop (info) {
        // eslint-disable-next-line
        var for_update = info.dragNode.$options.propsData.eventKey
        var new_parent = info.node.$options.propsData.eventKey
        var categoryPayload = {category: {parent_category_id: new_parent} }
        this.gData = await HTTPRequest.putRequest(this.endPoint + '/categories/' + for_update , null, categoryPayload)   
        gData = this.gData
        generateList(gData)
      },
    },
  };
</script>

<style></style>
